import { FC } from 'react';
import Card from '@/components/card';
import { Box, Stack, Theme } from '@mui/material';
import CardHeader from '../card/card-header';
import NoneChip from '../chip/none-chip';
import { OrgModel, OrgModeOptions } from '@/lib/models/org.model';
import { createUseStyles } from 'react-jss';
import { DateFormat, getNiceDate } from '@/lib/helpers';
import StatusChip from '../chip/status-chip';
import Text from '../text';

interface Props {
  org: OrgModel;
}

const useStyles = createUseStyles((theme: Theme) => ({
  entitlementCard: {
    padding: 10,
    borderLeft: `4px solid ${theme.palette.gray}`,
  },
}));

const EntitlementCard: FC<Props> = ({ org }) => {
  const { startDate, term, mode, status } = org;
  const styles = useStyles();

  const StartDateEl = startDate ? (
    getNiceDate(startDate, DateFormat.NOTIME).formatted
  ) : (
    <NoneChip />
  );

  const TermEl = term ? `${term} months` : <NoneChip />;

  return (
    <Card>
      <CardHeader title="Entitlement" icon="receipt" />
      <Box width="100%">
        <Box className={styles.entitlementCard} width="100%" mb={2}>
          <Stack direction="row" justifyContent="space-between">
            <Box width="50%">
              <Text bold inline>
                Mode:
              </Text>{' '}
              {OrgModeOptions.find(({ value }) => value === mode)?.label}
            </Box>
            <Box width="50%">
              <Text bold inline>
                Start Date:
              </Text>{' '}
              {StartDateEl}
            </Box>
          </Stack>

          <Stack direction="row" justifyContent="space-between" mt={2}>
            <Box width="50%">
              <Text bold inline>
                Status:
              </Text>{' '}
              <StatusChip value={status} size="small" />
            </Box>
            <Box width="50%">
              <Text bold inline>
                Term:
              </Text>{' '}
              {TermEl}
            </Box>
          </Stack>
        </Box>
      </Box>
    </Card>
  );
};

export default EntitlementCard;
